import styled from "styled-components";

export const Main = styled.div`
  display: grid;
  width: 100%;

  grid-template-columns: 40px 1fr 20px;
  column-gap: 16px;
  align-items: center;
  padding: 16px;
  cursor: pointer;

  border-radius: 6px;
  border: 1px solid
    ${(props) =>
      props.selected
        ? "var(--brand-colors-constellation-blue-300, #9EBCFA)"
        : "var(--extended-colors-gray-500, #6E717F)"};

  color: ${(props) =>
    props.selected
      ? "var(--brand-colors-constellation-blue-300, #9EBCFA)"
      : "var(--brand-colors-constellation-blue-100, #E2E9FD)"};

  .radioButton {
    color: ${(props) =>
      props.selected
        ? "var(--brand-colors-constellation-blue-300, #9EBCFA)"
        : "var(--extended-colors-gray-500, #6E717F)"};
  }
`;

export const IconContainer = styled.div`
  display: flex;
  width: 40px;
  height: 40px;

  justify-content: center;
  padding: 9px;
  align-items: center;
  border-radius: 40px;
  border: 1px solid
    ${(props) =>
      props.selected
        ? "var(--brand-colors-constellation-blue-300, #9EBCFA)"
        : "var(--brand-colors-constellation-blue-100, #E2E9FD)"};

  img {
    width: 100‰;
  }
`;

export const LabelConatiners = styled.div`
  display: flex;

  flex-flow: column nowrap;
  align-items: flex-start;

  span:nth-child(1) {
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
    letter-spacing: 0.16px;
  }

  span:nth-child(2) {
    opacity: 0.66;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.24px;
  }
`;
